import $ from 'jquery';

export default class ConfigLoader {
    constructor() {
        this.store = {};
        this.site_code = null;
    }

    getSiteCode() {
        if( this.site_code == null ){
            let douglas_sitecode = "jarvin";
            let query_string = `?site_code=${douglas_sitecode}&cmd=login&mac=m0:9e:0l:5o:0d:6y&essid=MCIA_DEV&ip=192.168.90.99&apname=%2F&vcname=instant-F5%3AD1%3AAE&switchip=securelogin.arubanetworks.com&url=http%3A%2F%2Fwww.bing.com%2F`;
            if( typeof location != 'undefined' ){
                query_string = location.search;
            }
        
            let find_sitecode = query_string.split("&");
            let filter_sitecode = find_sitecode.filter((qt) => {
                const str = qt.split("=");
                if( str[0].indexOf("site_code") != -1 ){
                    return true;
                }
                return false;
            });
        
            if( filter_sitecode.length > 0 ){
                douglas_sitecode = filter_sitecode[0].split("=")[1];
            }
            
            this.site_code = douglas_sitecode;
        }

        return this.site_code;
    }


    loadConfig( callback ) {
        $.getJSON(`${this.getSiteCode()}_config.json`)
            .then( data => {
                if( typeof callback == 'function' ){
                    this.store = data;
                    callback(data);
                    // $(document).trigger("config::loaded", data);
                }
            })
            .fail( ( xhr, text_status, error ) => {
                console.log('Error', text_status, error);
            });
    }

}


// WEBPACK FOOTER //
// ./src/config_loader.js